import { ButtonElement } from '@typedream/core';
import { getNode, setNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { ELEMENT_BUTTON } from '../../../pluginKeys';
import { DreamEditor } from '../../../types';

const defaultIcon: ButtonElement['icon'] = {
  content: {
    type: 'regular',
    name: 'cloud',
    color: 'white',
  },
  type: 'icon',
};

export const addButtonIcon = (editor: DreamEditor, at: Path) => {
  const element = getNode(editor, at);
  if (element?.type !== ELEMENT_BUTTON) return;
  setNodes(editor, { icon: defaultIcon }, { at });
};
